module.exports = "<div> {{PrinterServiceData.reportId}}\n</div>\n<div>\n    <lfwms-iframe [iframeUrl]=\"iframeUrl\" [width]=\"width\" [height]=\"height\"></lfwms-iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/jreport/jreport-print/jreport-print.component.html
// module id = ../../../../../src/app/shared/jreport/jreport-print/jreport-print.component.html
// module chunks = main